export default __webpack_public_path__ + "static/step_lab-7091d7b950184fd05a77955b7427e735.webp";